import { createSelector } from '@reduxjs/toolkit';

const selectFaqState = (state) => state.FAQ;

const selectFaqData = (state) => ({
    faqs: state.FAQ.faqs,
    loading: state.FAQ.loading,
    error: state.FAQ.error
});

const selectFaqEditData = (state) => ({
    currentFaq: state.FAQ.currentFaq,
    loading: state.FAQ.loading,
    error: state.FAQ.error
});

const selectSubFaqData = (state) => {
    console.log("Selector State:", state);
    return {
        subFaqs: state.FAQ.subFaqs,
        loading: state.FAQ.loading,
        error: state.FAQ.error
    };
};

// Single export statement for all selectors
export {
    selectFaqState,
    selectFaqData,
    selectFaqEditData,
    selectSubFaqData
}; 